var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXButtonListe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XBUTTONLISTE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 237, 0)",
    d: "M37.947,0.0 C58.905,0.0 75.895,16.989 75.895,37.947 C75.895,58.905 58.905,75.895 37.947,75.895 C16.989,75.895 0.0,58.905 0.0,37.947 C0.0,16.989 16.989,0.0 37.947,0.0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(5, 121, 200)",
    d: "M54.412,54.417 C53.490,55.338 51.995,55.338 51.73,54.417 L37.102,40.457 L24.5,53.544 C23.99,54.450 21.628,54.450 20.720,53.544 C19.812,52.638 19.812,51.168 20.720,50.261 L33.817,37.175 L21.26,24.395 C20.105,23.474 20.105,21.980 21.26,21.59 C21.948,20.138 23.443,20.138 24.365,21.59 L37.155,33.839 L50.288,20.716 C51.196,19.809 52.668,19.809 53.575,20.716 C54.482,21.623 54.482,23.93 53.575,23.999 L40.441,37.121 L54.412,51.81 C55.334,52.3 55.334,53.496 54.412,54.417 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXButtonListe);
export default __webpack_public_path__ + "static/media/xButtonListe.20abfa94.svg";
export { ForwardRef as ReactComponent };